<template>
  <div v-if="item.isShow()" class="menu-wrapper">
    <router-link v-if="!hasOneShowingChild(item.children)" :to="resolvePath(item.path)">
      <el-menu-item :index="resolvePath(item.path)" :class="{'submenu-title-noDropdown':!isNest}">
        <svg-icon v-if="item.meta && item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
        <span v-if="item.meta && item.meta.title" slot="title">{{ item.meta.title }}</span>
      </el-menu-item>
    </router-link>

    <el-submenu v-else :index="item.name || item.path">
      <template slot="title">
        <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
        <span v-if="item.meta&&item.meta.title" slot="title">{{ item.meta.title }}</span>
      </template>

      <template v-for="child in item.children">
        <template v-if="child.isShow()">
          <sidebar-item
            :is-nest="true"
            class="nest-menu"
            v-if="child.children && child.children.length > 0"
            :item="child"
            :key="child.path"
            :base-path="resolvePath(child.path)"
          ></sidebar-item>

          <router-link v-else :to="resolvePath(child.path)" :key="child.name">
            <el-menu-item :index="resolvePath(child.path)">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{ child.meta.title }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </template>
    </el-submenu>
  </div>
  <div v-else-if="hasOneShowingChild(item.children)">
    <sidebar-item
      v-for="route in item.children"
      :key="route.path"
      :is-nest="isNest"
      :class="{'nest-menu': isNest}"
      :item="route"
      :base-path="route.children && route.children.length ? resolvePath(route.path) : basePath"
    ></sidebar-item>
  </div>
</template>

<script>
import path from 'path'

export default {
  name: 'SidebarItem',
  props: {
    // route配置json
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      onlyOneChild: null
    }
  },
  methods: {
    hasOneShowingChild(children) {
      return children ? children.some(item => {
        if (!item.isShow()) {
          return false
        } else {
          // temp set(will be used if only has one showing child )
          this.onlyOneChild = item
          return true
        }
      }) : false
    },
    resolvePath(...paths) {
      return path.resolve(this.basePath, ...paths)
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-wrapper {
  /deep/ .el-submenu__title {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }

  .el-menu-item {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
}
</style>
